import React from 'react';
import { Typography, Box, Button, useTheme } from '@mui/material';

interface SidebarHeaderProps {
  title: string;
  onClose?: () => void;
  onSave?: (e: React.FormEvent<HTMLFormElement>) => void;
  loading?: boolean;
}

export const SidebarHeader = ({
  title,
  onClose = undefined,
  onSave = undefined,
  loading = false,
}: SidebarHeaderProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        backgroundColor: 'white',
        zIndex: 1000,
      }}
    >
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: theme.spacing(2),
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Typography variant="h6">{title}</Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          {onClose && (
            <Button
              disabled={loading}
              onClick={onClose}
              size="small"
              variant="outlined"
              color="secondary"
            >
              Close
            </Button>
          )}
          {onSave && (
            <Button
              disabled={loading}
              size="small"
              variant="contained"
              color="secondary"
              type="submit"
            >
              Save
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};
